let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cEm5a")).then(() => parcelRequire('f5h6d'));